/**
 * Action for wordpress/pages module
 */
import wpAPI from '@/api/wordpress'
import {errorHandler} from '@/helpers'
import types from './types'

const actions = {
  /**
   * 固定ページ一覧の取得
   */
  async [types.FETCH] ({ dispatch, commit, getters, rootGetters }) {
    return wpAPI.getPages().then(res => {
      commit(types.FETCH, res.data)
      return res.data
    }).catch(errorHandler)
  },

  /**
   * 新規固定ページの作成
   */
  async [types.CREATE] ({ dispatch, commit, getters, rootGetters }, page) {
    return wpAPI.createPage({
      date: page.date,
      slug: page.slug,
      status: page.status,
      parent: page.parent,
      title: page.title,
      content: page.html,
      author: rootGetters['wordpress/account/id'],
      menu_order: page.menu_order,
      css: page.css,
      header: page.header,
      extensions: page.extensions,
      components: page.components
    }).then(res => {
      commit(types.CREATE, res.data)
      return res.data
    }).catch(errorHandler)
  },

  /**
   * 固定ページの更新
   */
  async [types.UPDATE] ({ dispatch, commit, getters, rootGetters }, page) {
    /**
     * 一度非公開にするとページタイトルに『非公開: 』という文字が追加される。
     * ここでは page.status が private 以外かつタイトルの頭に『非公開: 』がつく場合は
     * 『非公開: 』をタイトルから削除する
     */
    if (page.status !== 'private' && page.title.rendered.startsWith('非公開: ')) page.title.rendered = page.title.rendered.replace(/非公開: /, '')
    return wpAPI.updatePage(page.id, {
      date: page.date,
      slug: page.slug,
      status: page.status,
      parent: page.parent,
      title: page.title.rendered,
      content: page.html,
      menu_order: page.menu_order,
      css: page.css,
      header: page.header,
      extensions: page.extensions,
      components: page.components
    }).then(res => {
      commit(types.UPDATE, res.data)
      return res.data
    }).catch(errorHandler)
  },

  /**
   * 固定ページの削除
   */
  async [types.DELETE] ({ dispatch, commit, getters, rootGetters }, id) {
    return wpAPI.deletePage(id).then(res => {
      commit(types.DELETE, res.data.previous)
      return res.data.previous
    }).catch(errorHandler)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/pages/actions.js